import { Overlay } from 'ol';
import RadialMenu from './RadialMenu';

export default class RadialMenuOverlay extends Overlay {
  constructor() {
    const radialMenu = new RadialMenu();
    super({
      element: radialMenu.dom,
      offset: [-104, -105],
    });

    this.radCpt_ = radialMenu;
  }

  /**
     * Show the element.
     * @param {Array<ItemOptions>} items The menu items.
     */
  show(items) {
    this.radCpt_.show(items);
  }

  /**
     * Hide the element.
     */
  hide() {
    this.radCpt_.hide();
  }
}
